import React, {useState} from 'react';
import __ from "lodash";
import IconButton from "@material-ui/core/IconButton";
import {
  ClickAwayListener,
  Grow,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Paper,
  Popper,
  Tooltip,
} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import NestedMenu from "./NestedMenu";

/* =============================================================================== */
//  Props:
//                 icon=< the Icon component to display >
//                 size="small" or "medium
//                 style={ object containing style properties }
//                 tooltip= tooltip text
//                 menuItems=[ array of menu objects or strings]
//                 callback= callback function to call on selection
//                 callbackParams={ object containing values to pass to the
//                                  callback function }
//
//                  menuItem Object {
//                                    itemLabel: text to display for the menu option
//                                    itemIcon: icon component to display in front of label
//                                    secondary: secondary component to display after the label
//                                  }
//
//  return:
//                 calls the callback function adding the selected menu item as
//                 a "selectedOption" property of the callbackParams
//
/* =============================================================================== */

const StyledListItem = withStyles(theme => ({
  root: {
    // '&:focus': {
    //   backgroundColor: theme.palette.primary.main,
    //   '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
    //     color: theme.palette.common.white,
    //   },
    // },
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.2)'
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'rgba(0,0,0,0.5)'
    },

  },
}))(MenuItem);

const StyledNestedMenuItem = withStyles(theme => ({
  root: {
    // '&:focus': {
    //   backgroundColor: theme.palette.primary.main,
    //   '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
    //     color: theme.palette.common.white,
    //   },
    // },
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.2)'
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'rgba(0,0,0,0.5)'
    },
  },
}))(NestedMenu);

const buildMenuItems = (menuItems, style, handleMenuClose) => {
  return menuItems.map((menuItem, i) => {
    const listItemLabel = __.isString(menuItem) ? menuItem : menuItem.itemLabel;
    const listItemIcon = __.has(menuItem, "itemIcon") ? <ListItemIcon style={style}>{menuItem.itemIcon}</ListItemIcon> : <></>;
    const listItemSecondary = __.has(menuItem, "secondary") ? <ListItemSecondaryAction>{menuItem.secondary}</ListItemSecondaryAction> : <></>;
    const hasMenu = __.has(menuItem, "itemMenu");
    const disabled = __.has(menuItem, "disabled") && menuItem.disabled !== false;

    const handleMenuClick = (e) => {
      console.log(menuItem.action);
      console.log(e);
      handleMenuClose(e, menuItem.action, menuItem.extraData);
    }
    if (hasMenu) {
      return (
        <StyledNestedMenuItem key={i} zIndex={2001} leftIcon={listItemIcon} label={listItemLabel} parentMenuOpen={true} disabled={disabled}>                            
          {buildMenuItems(menuItem.itemMenu, style, handleMenuClose)}
        </StyledNestedMenuItem>
      );
    }

    return (
      <StyledListItem 
        disabled={disabled}
        key={`${listItemLabel}_${i}`} 
        role={undefined} button 
        onClick={handleMenuClick}//menuItem.action?(e)=>{handleMenuClose(e, menuItem.action, menuItem.extraData)}:handleMenuClose}
      >
        {listItemIcon}
        <ListItemText id={listItemLabel} primary={listItemLabel} />
        {listItemSecondary} 
      </StyledListItem>
    )
  })
}

const IconButtonMenu = (props) => {

  const [openMenu, setOpenMenu] = React.useState(false);
  const anchorRef = React.useRef(null);

  const menuItems = props.menuItems;
  const callback = props.callback;
  let callbackParams = props.callbackParams;

  const handleToggle = () => {
    setOpenMenu((prevOpen) => !prevOpen);
  };

  const [menuPosition, setMenuPosition] = useState(null);

  const handleMenuClose = (event, action, extraData) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    const items = [];
    const unpackMenu = (menuItems, items) => {
      menuItems.forEach((menuItem) => {
        items.push (__.isString(menuItem) ? menuItem : menuItem.action);
        if (__.has(menuItem, 'itemMenu')) {
          unpackMenu(menuItem.itemMenu, items);
        }
      });  
    }
    unpackMenu(menuItems, items);

    if (action && items.includes(action)) {
      callbackParams["selectedOption"] = event.currentTarget.outerText;
      try {
        callbackParams["selectedOption"] = event.currentTarget.getElementsByClassName('MuiListItemText-root')[0].innerText;
      } catch (e) {}
      callbackParams["selectedAction"] = action;
      callbackParams["extraData"] = extraData;
      callback(callbackParams);
    } else if (event.currentTarget && items.includes(event.currentTarget.outerText)) {
      callbackParams["selectedOption"] = event.currentTarget.outerText;
      try {
        callbackParams["selectedOption"] = event.currentTarget.getElementsByClassName('MuiListItemText-root')[0].innerText;
      } catch (e) {}
      callback(callbackParams);
    }

    setOpenMenu(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab' || event.key === 'Escape') {
      event.preventDefault();
      setOpenMenu(false);
    }
  }

  if (props.disabled) {
    return (
      <IconButton
      disabled={props.disabled}
      size={props.size}
      style={props.style}
      ref={anchorRef}
    >
      {props.icon}
    </IconButton>
    ) 
  }
  return <React.Fragment>
    <div style={{marginTop: props.offset}}>
      <Tooltip title={props.tooltip}>
        <IconButton
          disabled={props.disabled}
          size={props.size}
          style={props.style}
          ref={anchorRef}
          onClick={ handleToggle }
        >
          {props.icon}
        </IconButton>
      </Tooltip>
      <Popper open={openMenu} anchorEl={anchorRef.current} transition  style={{ zIndex: props.zIndex || 100 }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'length top' : 'length bottom' }}
          >
            <Paper style={{border: '1px solid #d3d4d5',}}>
              <ClickAwayListener onClickAway={handleMenuClose}>
                <MenuList>
                  {
                    buildMenuItems(menuItems, props.style, handleMenuClose)
                  }
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  </React.Fragment>

}

export default IconButtonMenu;
export {
  buildMenuItems
}